module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_3_2_3.95960b91.png";